import { PropertyConverter } from 'angular2-jsonapi'
import { OperadoraDeMaquina } from '../operadora-de-maquina.model'

export class OperadoraDeMaquinaConverter implements PropertyConverter {
    static toModel(obj: any): OperadoraDeMaquina {
        if (obj instanceof OperadoraDeMaquina) {
            return obj
        }

        const model = new OperadoraDeMaquina(null)

        model.id = obj.id
        model.codename = obj.codename
        model.nome = obj.nome
        model.cnpj = obj.cnpj
        model.robo = obj.robo
        model.limiteParaSincronizaremMeses = obj.limiteParaSincronizaremMeses
        model.antecipa = obj.antecipa
        model.informaLiquido = obj.informaLiquido
        model.numeraEstabelecimento = obj.numeraEstabelecimento

        return model
    }

    static toJSON(model: OperadoraDeMaquina) {
        const json: any = Object.assign({}, model)

        return json
    }

    mask(value: any) {
        return OperadoraDeMaquinaConverter.toModel(value)
    }

    unmask(value: any) {
        return OperadoraDeMaquinaConverter.toJSON(value)
    }
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/collect/converters/operadora-de-maquina.converter.ts